// extracted by mini-css-extract-plugin
export default {"btn":"ViewDoc_btn__QjNrZ"};